import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  position: () => css`
    position: absolute;
    bottom: 44px;
    left: 10px;
    z-index: 1;

    & + div > div > div:nth-of-type(2) {
      padding-bottom: 44px;
    }
  `,
  pill: ({ theme }) => css`
    & > div {
      max-width: 250px;

      & > div:nth-of-type(2) {
        text-transform: unset;
        font-size: ${theme.fonts.supporting.helper.fontSize}px;
      }
    }
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
